const rolesWebCId = {
  accion: [{ path: '/', sub: null }, { path: '/destinatarios', sub: null }],
  label: 'Usuario',
};

export default rolesWebCId;
